import dayjs, { Dayjs } from "dayjs";
import { useCallback, useState } from "react";

export function useWeekRange(initialDate = dayjs()) {
  const [selectedDate, setSelectedDate] = useState<Dayjs>(initialDate);
  const [range, setRange] = useState(() => ({
    startTs: initialDate.weekday(0).startOf('day').unix(),
    stopTs: initialDate.weekday(6).endOf('day').unix()
  }));

  const setWeekByDate = useCallback((newDate: Dayjs) => {
    setSelectedDate(newDate);
    setRange({
      startTs: newDate.weekday(0).startOf('day').unix(),
      stopTs: newDate.weekday(6).endOf('day').unix()
    })
  }, []);

  const navigateWeek = useCallback((direction: 1 | -1) => {
    const newDate = selectedDate.add(direction, 'week');
    setWeekByDate(newDate);
  }, [selectedDate, setWeekByDate]);

  return {
    selectedDate,
    range,
    setWeekByDate,
    navigateWeek,
    previousWeek: () => navigateWeek(-1),
    nextWeek: () => navigateWeek(1)
  };
}